import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	flagTitle: {
		id: 'fabric-media-support.tasklist.error.flag.title',
		description: 'Flag title to inform user that an attempt to toggle a tasklist checkbox failed',
		defaultMessage: 'Something went wrong',
	},
	flagDescription: {
		id: 'fabric-media-support.tasklist.error.flag.description',
		description:
			'Flag description to inform user that an attempt to toggle a tasklist checkbox failed',
		defaultMessage:
			'An error occurred while trying to change a task’s status. Please try again later.',
	},
});
